import React from 'react';
import { Alert, ProgressBar } from 'react-bootstrap';

/**
 * Reusable Loading Progress Component
 * Displays an animated progress bar with a loading message
 * 
 * @param {boolean} isLoading - Whether to show the loading indicator
 * @param {string} message - The message to display during loading
 * @param {number} progress - Progress percentage (0-100)
 * @param {string} variant - Bootstrap variant for progress bar (default: 'success')
 * @param {string} className - Additional CSS classes
 */
const LoadingProgress = ({ 
  isLoading, 
  message = 'Loading...', 
  progress = 0, 
  variant = 'success',
  className = ''
}) => {
  if (!isLoading) return null;

  return (
    <div className={`pd-10 mb-15 ${className}`}>
      <Alert variant="info" className="mb-10">
        <div className="d-flex align-items-center">
          <i className="fa fa-spinner fa-spin mr-10"></i>
          <span>{message}</span>
        </div>
      </Alert>
      <ProgressBar 
        now={progress} 
        label={`${progress}%`}
        variant={variant}
        striped
        animated
      />
    </div>
  );
};

export default LoadingProgress;